import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";

export const NAVIGATION_TREE_HASH_CODE_PROPERTY_NAME = "navigationTreeHashCode";
export const getNavigationTreeHashCode = (): string | undefined =>
  getGlobalProperty<string>(NAVIGATION_TREE_HASH_CODE_PROPERTY_NAME);
